const showToolPreview = (el) => {
	el.parentNode.querySelector('.tool__modal').classList.add('active')
}

const closeToolPreview = el => {
	el.parentNode.parentNode.classList.remove('active')
}

const setQueryCheckbox = (chosenTool) => {
	const checkBoxes = document.querySelectorAll('[name="wpforms[fields][2][]"]')
	console.log(checkBoxes);
	checkBoxes.forEach(cb => {
		if (cb.value === chosenTool) {
			cb.checked = true
		}
	})
}